module.exports = __webpack_public_path__ + "img/cart-flatbed-suitcase.fe4514cd.svg";